import React from 'react'
import { Link } from 'react-router-dom';
import item1 from '../assets/images/items/1.jpg';

export default function CollectionTwo(props) {
    const { title, description, data } = props;
    return (
        <>
            <div className={`container ${title !== undefined ? 'md:mt-24 mt-16' : ''}`}>
                {
                    data.title !== undefined ? (
                        <div className="grid grid-cols-1 text-center">
                            <h3 className="mb-4 md:text-3xl text-2xl md:leading-snug leading-snug font-semibold">{title}</h3>
                            <p className="text-slate-400 max-w-xl mx-auto">{description}</p>
                        </div>
                    ) : ('')
                }

                <div className={`grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-[30px] ${title !== undefined ? 'mt-12' : ''}`}>
                    {
                        data.map((item, index) => (
                            <div key={index} className="group relative overflow-hidden bg-white dark:bg-slate-900 rounded-lg p-3 shadow hover:shadow-md dark:shadow-gray-800 dark:hover:shadow-gray-800 hover:scale-105 ease-in-out duration-500">
                                <img src={item.img} className="rounded-lg" alt="" />

                                <div className="relative p-4 -mt-14">
                                    <div className="relative inline-block">
                                        <i className="mdi mdi-check-decagram text-emerald-600 text-2xl absolute -bottom-3 right-0"></i>
                                    </div>

                                    <div className="mt-6">
                                        <p className="font-semibold block text-[18px] hover:text-violet-600 ">{item.title}</p>
                                        <span className="text-slate-400 block text-[16px] mt-1">{item.description}</span>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>

        </>
    )
}
